module.exports = __webpack_public_path__ + "media/S_Chime.a5d18a75.ogg";